import { MotionReveal, MotionText } from "../components/MotionReveal";
import defaultHeroImage from "../assets/construction3.png";

export default function PageHero(props) {
  const {
    eyebrow,
    title,
    text,
    image = defaultHeroImage,
  } = props;

  return (
    <section
      className="tgm-page-hero"
      style={{ "--tgm-page-hero-image": `url("${image}")` }}
    >
      <div className="container">
        <div className="tgm-page-hero-copy">
          {eyebrow ? (
            <MotionReveal
              as="p"
              className="tgm-page-hero-eyebrow"
              variant="soft"
            >
              {eyebrow}
            </MotionReveal>
          ) : null}
          <MotionText as="h1" className="tgm-page-hero-title" text={title} />
          {text ? (
            <MotionReveal
              as="p"
              className="tgm-page-hero-text"
              variant="soft"
              delay={0.22}
            >
              {text}
            </MotionReveal>
          ) : null}
        </div>
      </div>
    </section>
  );
}
